import { LuLink } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { useConnectZoom } from 'views/calendar/calendar-queries';

export const ConnectZoomButton = () => {
    const connectZoom = useConnectZoom();

    const handleConnect = () => {
        connectZoom.mutateAsync();
    };

    return (
        <div className="flex gap-2 pt-6">
            <Button onClick={handleConnect} className="flex items-center gap-2">
                <LuLink className="h-4 w-4" />
                Connect Zoom
            </Button>
        </div>
    );
};
